import React, { useState } from 'react';
import { Edit2, Save, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { toast } from 'sonner';
import { adminApi, API_ENDPOINTS } from './api';

const ProgramForm = ({ item, onSave, onCancel }) => {
  const [f, setF] = useState({
    title: item?.title || '', short_description: item?.short_description || '',
    full_description: item?.full_description || '', beneficiaries: item?.beneficiaries || '',
    how_to_support: item?.how_to_support || '',
  });
  const up = (k, v) => setF(p => ({ ...p, [k]: v }));
  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-6 mb-5">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-bold text-gray-900">Modifier: {item?.title}</h3>
        <button onClick={onCancel}><X className="w-5 h-5 text-gray-400" /></button>
      </div>
      <form onSubmit={e => { e.preventDefault(); onSave(f); }} className="space-y-3">
        <div><Label className="text-xs text-gray-500">Titre</Label><Input value={f.title} onChange={e => up('title', e.target.value)} className="h-9" /></div>
        <div><Label className="text-xs text-gray-500">Description courte</Label><Textarea value={f.short_description} onChange={e => up('short_description', e.target.value)} rows={2} /></div>
        <div><Label className="text-xs text-gray-500">Description complete</Label><Textarea value={f.full_description} onChange={e => up('full_description', e.target.value)} rows={4} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs text-gray-500">Beneficiaires</Label><Input value={f.beneficiaries} onChange={e => up('beneficiaries', e.target.value)} className="h-9" /></div>
          <div><Label className="text-xs text-gray-500">Comment soutenir</Label><Input value={f.how_to_support} onChange={e => up('how_to_support', e.target.value)} className="h-9" /></div>
        </div>
        <div className="flex gap-2">
          <Button type="submit" className="bg-gray-900 hover:bg-gray-800 h-9 rounded-lg text-sm"><Save className="w-4 h-4 mr-1.5" />Sauvegarder</Button>
          <Button type="button" variant="outline" onClick={onCancel} className="h-9 rounded-lg text-sm">Annuler</Button>
        </div>
      </form>
    </div>
  );
};

export const ProgramsTab = ({ programs, onReload }) => {
  const [edit, setEdit] = useState(null);

  const saveProg = async (d) => {
    try {
      await adminApi.put(API_ENDPOINTS.adminPrograms(edit.slug), d);
      toast.success('OK');
      setEdit(null);
      onReload();
    } catch (err) {
      console.error('Save program failed:', err);
      toast.error('Erreur lors de la sauvegarde');
    }
  };

  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold text-gray-900">Programmes ({programs.length})</h1>
      {edit && <ProgramForm item={edit} onSave={saveProg} onCancel={() => setEdit(null)} />}
      <div className="grid md:grid-cols-2 gap-4">
        {programs.map(p => (
          <div key={p.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-md transition-all group">
            <div className="h-36 overflow-hidden">
              <img src={p.images?.[0]} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-4 flex items-start justify-between">
              <div>
                <h3 className="font-semibold text-gray-900 text-sm">{p.title}</h3>
                <p className="text-xs text-gray-500 mt-1 line-clamp-2">{p.short_description}</p>
              </div>
              <button onClick={() => setEdit(p)} className="p-2 rounded-lg hover:bg-gray-100 flex-shrink-0">
                <Edit2 className="w-3.5 h-3.5 text-gray-500" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
